import { Boton, Panel } from '../components/kit'

export default function NoEncontrado() {
  return (
    <div className="pagina-centrada">
      <Panel titulo="Página no encontrada">
        <div className="pila">
          <p>La dirección no existe o cambió.</p>
          <Boton to="/">Volver al inicio</Boton>
        </div>
      </Panel>
    </div>
  )
}
